<template>
  <div>

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">
        {{ snackbar_msg }}
      </span>

      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>

    <v-card class="box no-display" v-if="ay_std_div_list != null && inst_list != null">

      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Training Hours Report</strong>
        </v-toolbar-title>
      </v-toolbar>

      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>

          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined />
        </v-col>
           <v-col sm="2">
          <v-icon color="error">*</v-icon>

          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_activity_data" return-object
            :items="activity_list_with_all" item-text="title" label="Activity" outlined />
        </v-col>
         <v-col sm="2">
          <v-icon color="error">*</v-icon>

          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_faculty_data" return-object
            :items="inst_list_with_all" item-text="name" label="Faculty" outlined />
        </v-col>
        <v-col sm="2">
          <v-btn class="mt-2 button" @click="getReport()" :loading="fetch_loader">
            Fetch
          </v-btn>
        </v-col>

      </v-row>

    </v-card>

    <v-card class="box" v-if="training_hours_report && training_hours_report.length > 0">

      <v-col cols="12" sm="12" md="12">
        <v-btn class="ma-2 no-display" rounded color="success" outlined
          @click="fnExcelReport('my-table-id', 'TrainingHoursReport')">
          <v-icon color="success">
            mdi-export
          </v-icon>

          Export
        </v-btn>

      </v-col>

      <div id="my-table-id">

        <v-data-table :headers="headers1" :items="training_hours_report" :search="search" dense class="elevation-1 mytable">
          <template v-slot:item.is_appraised_linked="{ item }">
                            <span v-if="item.is_appraised_linked===true">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
          </template>
        </v-data-table>
      </div>

    </v-card>

  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {

      fetch_loader: false,
    
      snackbar: false,
      snackbar_msg: "",
      color: "",
      search: "",
      ay_std_div_list: null,
      inst_list: null,
      inst_list_with_all: null,
      sel_ay_data: null,
      sel_faculty_data: null,
      activity_list_with_all: null,
sel_activity_data: null,

     training_hours_report:[],

      headers1: [
        {
          text: "Sr. No.",
          value: "sr_no",
        },
        {
          text: "Is Linked to Appraisal",
          value: "is_appraised_linked",
        },
        {
          text: "Employee Code",
          value: "employee_code",
        },
        {
          text: "Faculty Name",
          value: "employee_name",
        },
        {
          text: "Activity",
          value: "activity_name",
        },
        {
          text: "Category",
          value: "category",
        },
        {
          text: "Hours",
          value: "total_hours",
        },
      ],
    };
  },
  methods: {

   
fnExcelReport(id, name) {

  let tab_text = `
    <table border="1">
      <tr>
        <th>SR. No.</th>
        <th>Is Linked to Appraisal</th>
        <th>Employee Code</th>
        <th>Faculty Name</th>
        <th>Activity</th>
        <th>Category</th>
        <th>Hours</th>
      </tr>
  `;

  this.training_hours_report.forEach((item, index) => {

    tab_text += `
      <tr>
        <td>${index + 1}</td>
        <td>${item.is_appraised_linked === true ? "Yes" : "No"}</td>
        <td>${item.employee_code || "-"}</td>
        <td>${item.employee_name || "-"}</td>
        <td>${item.activity_name || "-"}</td>
        <td>${item.category || "-"}</td>
        <td>${item.total_hours != null ? item.total_hours : 0}</td>
      </tr>
    `;

  });

  tab_text += `
    </table>
  `;

  const blob = new Blob(
    [tab_text],
    {
      type: "application/vnd.ms-excel"
    }
  );

  const filename =
    name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {

    window.navigator.msSaveOrOpenBlob(
      blob,
      filename
    );

  } else {

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");

    a.href = url;
    a.download = filename;

    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);

    window.URL.revokeObjectURL(url);
  }
},




    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    getReport() {
      this.training_hours_report = [];
      this.fetch_loader = true;
      const formatDate = (date) => {
        if (!date) return null;

        const parts = date.split("-");

        if (parts.length === 3) {
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }

        return date;
      };

      const data = {
        ay: this.sel_ay_data ? this.sel_ay_data.id : null,
        faculty_id: this.sel_faculty_data ? this.sel_faculty_data.id : null,
        activity_id: this.sel_activity_data ? this.sel_activity_data.id : null,
        from_date: formatDate(this.from_date),
        to_date: formatDate(this.to_date),
      };

      console.log("TrainigHours Report Request:", data);

      axios
        .post("/Activity/getTrainingHoursReport", data)
        .then((res) => {
          console.log("TrainingHours Report Response:", res.data);

          if (res.data.training_hours_report) {
            this.training_hours_report = res.data.training_hours_report.map(
              (item, index) => {
                return {
                  ...item,
                  sr_no: index + 1,
                };
              }
            );
          } else {
            this.training_hours_report = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.showSnackbar(
            "#b71c1c",
            "Something went wrong..."
          );
        })
        .finally(() => {
          this.fetch_loader = false;
        });
    },


    onload() {

      axios
        .post("/Activity/getInitaialData")
        .then((res) => {
          this.ay_std_div_list = res.data.ay_list || [];
          this.inst_list = res.data.inst_list || [];
          this.inst_list_with_all = res.data.inst_list_with_all || [];
          this.activity_list_with_all = res.data.activity_list_with_all || [];

        })
        .catch((error) => {

          console.log(error);

          this.showSnackbar(
            "#b71c1c",
            "Something went wrong..."
          );

        });

    },
  },
  mounted() {
    this.onload();
  },
};
</script>

<style scoped>
.mytable2 /deep/ thead th {
  background: #0f2027 !important;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
